import Layout from '../../Components/Templates/Layout';
import SpaceImage from '../../Assets/Images/nasa-space.jpg';
import { Center, Flex, Heading } from '@chakra-ui/react';
import DocumentList from '../../Components/DocumentList/index';
import { policyDocuments, guidanceDocuments, certificationDocuments, termsAndConditionsDocuments } from './documentListData';

const Documents = () => {
    return (
        <Layout topBarMaxWidth={ 1400 }>
            <Flex flexDirection='column' flex='1'>
                <Flex flexDirection='row'>
                    <Flex 
                        flex='1' 
                        backgroundImage={ SpaceImage }
                        height='300px'
                        backgroundPosition='center'
                        backgroundSize='cover'
                    />
                </Flex>
                <Flex>
                    <Center display='flex' flex='1'>
                        <Flex 
                            flex='1' 
                            maxWidth='1400px' 
                            flexDirection='column'
                            padding='10px'
                        >
                            <Heading 
                                color='brand.orange'
                                marginTop='20px'
                                marginBottom='20px'
                            >
                                DOCUMENTS
                            </Heading>
                            <Flex flexDirection='column'>
                                <DocumentList 
                                    listTitle='Policy Documents'
                                    documents={ policyDocuments }
                                />
                                <DocumentList 
                                    listTitle='Certifications'
                                    documents={ certificationDocuments }
                                />
                                <DocumentList 
                                    listTitle='Guidance for Visitors & Contractors'
                                    documents={ guidanceDocuments }
                                />
                                <DocumentList 
                                    listTitle='T&Cs'
                                    documents={ termsAndConditionsDocuments }
                                />
                            </Flex>
                        </Flex>
                    </Center>
                </Flex>
            </Flex>
        </Layout>
    );
};

export default Documents;